/**
 * Show scripts.
 *
 * Handles interactive functinoality for showcase components
 */

/** Dependencies -------------------------------------------- */

// External
import EmblaCarousel from 'embla-carousel';
import Autoplay from 'embla-carousel-autoplay';

/** The beef ------------------------------------------------ */

/**
 * showcase mixin.
 */
export let mixin = ({ node = null, config = {} } = {}) => {
   let state = {
      node,
      config,
      slides: node.querySelector(`[data-js="slides"]`),
      controls: node.querySelectorAll(`[data-action]`),
      slider: null,
   };

   let module = {
      initPlugin() {
         if (!state.slides) return;

         state.slider = EmblaCarousel(
            state.node,
            {
               container: state.slides,
               slidesToScroll: 'auto',
               loop: true,
            },
            [
               Autoplay({
                  delay: 7500,
               }),
            ]
         );
      },

      prev() {
         state.slider.scrollPrev();
      },

      next() {
         state.slider.scrollNext();
      },

      onControlClick(e) {
         e.preventDefault();

         let clicked = e.currentTarget;
         let action = clicked.dataset.action;

         this[action]();
      },

      setEventBindings() {
         if (state.controls.length) {
            [...state.controls].map((control) => {
               control.addEventListener('click', this.onControlClick.bind(this));
            });
         }
      },
      init() {
         this.initPlugin();
         this.setEventBindings();
      },
   };

   return module.init();
};

/**
 * Filter module.
 * Provides an interface to apply filter functionality to all elements matching a selector.
 */
export default {
   init({ selector, config = {} }) {
      let selected = document.querySelectorAll(selector);

      if (!selected.length) return;

      return Array.from(selected).map((node, index) => mixin({ node, config }));
   },
};
